import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common'; 
import { TopdownAdjustmentComponent } from './topdown-adjustment.component';
import { TopdownAdjustmentRoutingModule } from './topdown-adjustment.routing';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';
import { FormsModule } from '@angular/forms';
import { DxDataGridModule, DxValidatorModule } from 'devextreme-angular';



@NgModule({
  declarations: [TopdownAdjustmentComponent],
  imports: [
    CommonModule, FormsModule, 
    TopdownAdjustmentRoutingModule,DevEpressCommonModule,DxDataGridModule, DxValidatorModule
  ]
})
export class TopdownAdjustmentModule { }
